/** Mirrors @neighbors-text-dark in variables.less — keep both in sync if it changes. */
export const NEIGHBORS_TEXT_DARK = '#1a2332';
